import { createContext, ReactNode, useContext } from "react";
import { createPortal } from "react-dom";
import { RestTimerCountdown } from "./components/RestTimerCountdown";
import { RestTimerController, useRestTimer } from "./hooks/useRestTimer";
import { useRestTimerNotifications } from "./hooks/useRestTimerNotifications";
import styles from "./WorkoutPlanDialog.module.scss";

const RestTimerContext = createContext<RestTimerController | null>(null);

export const RestTimerProvider = ({ children }: { children: ReactNode }) => {
  const notifications = useRestTimerNotifications();
  const controller = useRestTimer({
    getPushEndpoint: notifications.getPushEndpoint,
    onStart: notifications.refresh,
  });

  return (
    <RestTimerContext.Provider value={controller}>
      {children}
      {typeof document !== "undefined" &&
        createPortal(
          <div className={styles.rest_countdown_layer}>
            <RestTimerCountdown
              state={controller.state}
              onAdjust={controller.adjust}
              onSkip={controller.skip}
              notificationHint={notifications.hint}
            />
          </div>,
          document.body,
        )}
    </RestTimerContext.Provider>
  );
};

export const useRestTimerContext = (): RestTimerController => {
  const ctx = useContext(RestTimerContext);
  if (!ctx) {
    throw new Error(
      "useRestTimerContext must be used within a RestTimerProvider",
    );
  }
  return ctx;
};
